<template>
  <div class="content-single-501">
    <m-single-content-wrapper :contentLink="contentLink"
                              content-type="page">
      <template v-slot="{content}">
        <div class="row justify-content-center align-items-center p-2">


          <div class="col-lg-6 order-2 order-lg-1 text-center mx-auto">
            <img :src="content.thumbnail" :alt="content.title"
                 class="mx-auto  content-single-501-image text-center " alt="">
          </div>
          <div class="col-lg-6 order-1 content-single-501-content-wrapper ">
            <heading2 class="content-single-501-content-title p-0">
              <template #p-1><h2 class="content-title-wrapper-501 font-weight-bold text-primary">{{ content.title }}</h2></template>
              <template #p-2>
                {{content.keyword}}
                <span v-for="keyword in content.keywords" class="word word-wrapper-501">{{keyword.keyword}}</span>
              </template>
            </heading2>
            <div class="content-single-501-content-description pt-3" v-html="contentSlicer(content.body,700)"></div>
            <div class="container content-single-501-content-button p-0 mb-3">
              <m-a :href="findLinkOnContent(content.abstraction)">
                <div class="btn btn-primary text-white  button-text-wrapper "><i class="bi bi-person"></i> {{buttonText1}}</div>
              </m-a>

            </div>
          </div>


        </div>
      </template>
    </m-single-content-wrapper>
  </div>
</template>

<script>
import {ContentSingleProps} from "./ContentSingleProps";
import mSingleContentWrapper from "../../Wrappers/SingleContentWrapper";
import mA from "../../Tags/A";
import mButton2 from "../../Buttons/Button2";
import mCard906 from "../../Cards/Card906";
import mButton301 from "../../Buttons/Button301";
import Heading2 from "../../Heading/Heading2";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
  name: "ContentSingle501",
  methods: {contentSlicer},
  components: {Heading2, mA, mSingleContentWrapper, mButton2, mCard906, mButton301},
  props: {
    buttonText1: {
      default: "درباره ما",
    },
    ...ContentSingleProps
  },


}
</script>

<style scoped>
.content-single-501-image{
  border-radius: 16px;
  width: 100%;
}


.card906 >>> .card906-content .row {
  height: 100%;
  margin: auto;
}

@media only screen and (max-width: 447px) {
  .content-title-wrapper-501 {
    font-size: 20px;

  }
}

.content-title-wrapper-501 {
  border-bottom: 3px solid var(--secondary);
  font-size: 24px;
  padding-bottom: 8px;
}

.content-single-501-content-button .btn-primary{
  font-size: 14px;
  padding: 8px 16px;


}




</style>